<template>
    <div class="select_block mr-3">
        <div class="load_select color-primary" v-if="!is_load">
            <sync-loader :loading="true" color="#53644B" size="5px"></sync-loader>
        </div>

        <div class="select_inside " v-else>
            <v-select
                    class=""
                    @input="setActive"
                    v-model="current_item"
                    :options=draw_items
                    :label=active_filed_name
                    :searchable=true
                    :placeholder=placeholder
            >

                <template v-slot:option="option">
                    <div class="pt-2 pb-2">
                        <div class='icon-stack fs-xl mr-3'>
                            <i class="base base-19 icon-stack-3x opacity-100 color-primary-500"></i>
                            <i class="base base-2 icon-stack-2x opacity-100 color-primary-300"></i>
                            <i class="fas fa-arrow-right icon-stack-1x opacity-100 color-white"></i>
                        </div>
                        <span class="imc_opt">
                            {{debug_opt(option)}}
                        </span>
                    </div>

                </template>


            </v-select>

        </div>
    </div>

</template>

<script>
    import SyncLoader from 'vue-spinner/src/SyncLoader.vue'
    import vSelect from 'vue-select'
    export default {
        name: "imc_select",

        components: {
            SyncLoader,
            vSelect
        },

        props : {
            active_id : {
                type : Number,
                default : 0,
            },

            active_filed_name : {
                type : String,
                default : "text"
            },

            active_filed_val : {
                type : String,
                default : "value"
            },

            filter_name : {
                type : String,
                default :""
            },

            hidden_input : {
                type : String,
                required : true
            },

            onchange : {
                type: Object,
                default: () => ({
                    type: "vue_select",
                    trigger: "vue_select_trigger",
                })
            },

            items_url : {
                type : String,
                default : ""
            },

            placeholder : {
                type : String,
                default : "Оберіть параметр"
            },

            filter_state : {
                type : Object
            },

            items : {
                type : Array,
                default: () => []
            }
        },

        data() {
            return {
                is_load: false,
                draw_items : [],
                current_item : null,
            }
        },

        mounted()  {
            if(this.items.length > 0) {
                  this.draw_items = this.items;
            }

            if(this.items_url.length > 0) {
                this.load_items();
            }

        },
        methods: {
            debug_opt(option) {

                if(option.hasOwnProperty(this.active_filed_name)) {
                    return option[this.active_filed_name];
                }

                return "oops";
            },

            async load_items () {

                await api.get(this.items_url).then(({data}) => {
                    this.is_load = true;
                    if(data.status === "operation_success") {
                        this.draw_items = data.data;

                        try {
                            this.draw_items.map(item => {
                                if(item.hasOwnProperty(this.active_filed_val)) {
                                    if(parseInt(item[this.active_filed_val]) === parseInt(this.active_id)) {
                                        this.current_item = item;
                                    }
                                }
                            })
                        }
                        catch (e) {

                        }
                    }
                    else {
                        this.draw_items = [];
                    }
                }).catch(err => {
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
                    this.is_load = false;
                });
            },

            setActive(item) {
                if (myapp_config.debugState)
                    console.log("%c|___VUE_SELECT Item select plugin selected ", "color: #ffc241",item);

                this.current_item = item;

                EventBus.$emit("filter_select_change",{
                    "type" : this.filter_name,
                    "value" : this.cur_val
                });

               /* EventBus.$emit(this.onchange.trigger, {
                    type: this.onchange.type,
                    value : this.cur_val
                });

                jQuery("#imc_filter")
                    .find('input[name="'+ this.hidden_input+'"]')
                    .val(this.cur_val)
                    .change();*/

            }
        },

        computed: {
            cur_val () {
                if(this.current_item != undefined && this.current_item != null) {
                    if(this.current_item.hasOwnProperty(this.active_filed_val)) {
                        return this.current_item[this.active_filed_val];
                    }
                }

                return null;
            },

            filter_data() {
                let filter_dt = {};

                if(this.filter_state != undefined && this.filter_state != null) {
                    filter_dt.filter = this.filter_state;
                }

                return filter_dt;
            }

        }



    }
</script>

<style scoped>
    .select_inside {
        min-width: 250px;
    }
    .load_select {
        min-width:250px;
        text-align: center;
    }
</style>
